<c-card *transloco="let t">
  <c-card-body class="px-2">

          <c-row>
            <c-col md="12" lg="6">
                <h3>{{ t('Add a Monitor') }}</h3>
            </c-col>
            <c-col md="12" lg="6" class="text-end mb-2">

              <div class="btn-group mb-2 " role="group">
                <button color="light" cButton  routerLink="/mgmt/monitors/monitors">
                    <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                    {{ t('Return to Monitors') }}
                </button>
                <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
              </div>

            </c-col>
          </c-row>


        <c-row class="justify-content-left">
          <c-col>

                  <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">



                    <div class="row">
                      <div class="col-md-6">

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'name'"
                              cFormControl
                              placeholder="{{ t('Name') }}"
                              [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('A suitable name for this monitor')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                              {{ t('A valid name is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'email'"
                              cFormControl
                              placeholder="{{ t('Email') }}"
                              [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for email alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['email'].errors && f['email'].errors['required']" class="invalid-feedback">
                              {{ t('A valid email is required') }}
                            </div>
                            <div *ngIf="submitted && f['email'].errors && f['email'].errors['invalid']" class="invalid-feedback">
                              {{ f['email'].errors['invalid'] }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilMobile"></svg> {{ t('Cell Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone'"
                              cFormControl
                              placeholder="{{ t('For Text Messages') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for SMS alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Phone Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                              {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Phone Number') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone2'"
                              cFormControl
                              placeholder="{{ t('For Phone Calls') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone2'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Used for phone call alerts - please use the international code such as +44 for UK, or +1 for Canada. Can be the same as the Cell Number.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone2'].errors" class="invalid-feedback">
                              {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>


                        <div class="form-group row mb-2" >
                          <div class="col-8">
                            <input type="checkbox" class="form-check-input" formControlName="welcome" name="welcome">
                            <label class="form-check-label" for="welcome">&nbsp;{{ t('Send welcome email') }}</label>
                          </div>
                        </div>

                        <ng-container *ngIf="okService.hasFeature('learning_center')">
                          <div class="form-group row mb-2"  *ngIf="formGroup.value.phone.length > 0 || formGroup.value.email.length >0">
                            <div class="col-8">
                              <input type="checkbox" class="form-check-input" formControlName="learning" name="learning">
                              <label class="form-check-label" for="learning">&nbsp;{{ t('Send Learning Center link to the monitor') }}</label>
                            </div>
                          </div>
                        </ng-container>



                      </div>
                      <div class="col-md-6">


                        <div class="form-group row mb-2">
                          <label class="col-4 col-form-label text-start text-sm-end">{{ t('Contact Method:') }}</label>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose the method to contact the monitor, if none is chosen email will be used. SMS is not available in New Zealand at this time.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_email" name="use_email"  formControlName="use_email">
                                <label class="form-check-label" for="use_email">
                                  &nbsp; &nbsp;{{ t('Email') }}
                                </label>
                              </div>
                              <div class="col-6" >
                                <input class="form-check-input" type="checkbox" id="use_sms" name="use_sms"  formControlName="use_sms">
                                <label class="form-check-label" for="use_sms">
                                  &nbsp; &nbsp;{{ t('SMS') }}
                                </label>
                              </div>
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_phone" name="use_phone"  formControlName="use_phone">
                                <label class="form-check-label" for="use_phone">
                                  &nbsp; &nbsp;{{ t('Phone') }}
                                </label>
                              </div>
                              @if(okService.hasFeature('whatsapp')) {
                              <div class="col-6">
                                <input class="form-check-input" type="checkbox" id="use_whatsapp" name="use_whatsapp"  formControlName="use_whatsapp">
                                <label class="form-check-label" for="use_whatsapp">
                                  &nbsp; &nbsp;{{ t('WhatsApp') }}
                                </label>
                              </div>
                              }
                            </div>

                          </div>
                        </div>

                        <ng-container *ngIf="okService.settings.international">

                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilLocationPin"></svg> {{ t('Country') }}</label>
                            <div class="col-8">
                              <ng-select [items]="countryListArray"
                              bindLabel="name"
                              bindValue="code"
                              formControlName="country"
                              placeholder="{{ t('Country') }}">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The country of the monitor, required if they are in another country to the account country')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>

                          <div class="form-group row mb-2" >
                            <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-globe"></i> {{ t('Timezone') }}</label>
                            <div class="col-8">
                              <ng-select [items]="timezoneListArray"
                                        bindLabel="label"
                                        bindValue="tzCode"
                                        formControlName="timezone"
                                        placeholder="{{ t('Timezone') }}">
                              </ng-select>
                              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The timezone of the monitor, required if they are in another timezone to the account timezone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>

                        </ng-container>

                      </div>
                    </div>


                    <c-row>
                      <c-col xs="6" class="my-2">
                        <button cButton class="px-4 text-white btn-info" type="submit" [disabled]="submitting">
                          <svg cIcon name="cil-plus"></svg> {{ t('Add the Monitor') }}
                        </button>
                      </c-col>
                    </c-row>
                  </form>

          </c-col>
        </c-row>


  </c-card-body>
</c-card>
